// @systeme: interface
// Le report en un geste : ce soir · demain matin · samedi, ou une date choisie.
// Le serveur calcule l'instant ; ici on ne fait que transmettre le choix.
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { OptionReport } from '@foyer/shared';
import { tailles } from '../theme/theme';

interface Props {
  ouvert: boolean;
  onFermer(): void;
  onReporter(quand: OptionReport, date?: string): Promise<void>;
}

export function FeuilleReport({ ouvert, onFermer, onReporter }: Props) {
  const [date, setDate] = useState('');
  const [enCours, setEnCours] = useState(false);

  async function choisir(quand: OptionReport, d?: string) {
    setEnCours(true);
    try {
      await onReporter(quand, d);
      onFermer();
    } finally {
      setEnCours(false);
    }
  }

  return (
    <Drawer anchor="bottom" open={ouvert} onClose={onFermer}>
      <Box sx={{ px: `${tailles.marge}px`, pt: 2, pb: 'calc(24px + env(safe-area-inset-bottom))' }}>
        <Typography variant="h2" component="h2" sx={{ mb: 2 }}>
          Plutôt…
        </Typography>
        <Stack spacing={1.5}>
          <Button
            variant="outlined"
            size="large"
            disabled={enCours}
            onClick={() => choisir('ce_soir')}
          >
            Ce soir
          </Button>
          <Button
            variant="outlined"
            size="large"
            disabled={enCours}
            onClick={() => choisir('demain_matin')}
          >
            Demain matin
          </Button>
          <Button
            variant="outlined"
            size="large"
            disabled={enCours}
            onClick={() => choisir('samedi')}
          >
            Samedi
          </Button>
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              type="date"
              label="Un autre jour"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={{ 'aria-label': 'Choisir une date' }}
            />
            <Button
              variant="contained"
              disabled={enCours || date === ''}
              onClick={() => choisir('date', date)}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Ce jour-là
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Drawer>
  );
}
